export default __webpack_public_path__ + "static/media/shade.d5445665.png";